import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useRegister2 = () => {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
  const response = await axiosApi.post('/auth/register', {
        code: parseInt(code),
        password,
        name,
        role,
      });
      setSuccess(response.data.message || 'User registered successfully');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return {
    code, setCode,
    name, setName,
    password, setPassword,
    confirmPassword, setConfirmPassword,
    role, setRole,
    error, success, setError, setSuccess,
    handleSubmit,
  };
};

export default useRegister2;
